import { render, staticRenderFns } from "./stats-header.html?vue&type=template&id=add1dee6&scoped=true&external"
import script from "./stats-header.vue?vue&type=script&lang=js"
export * from "./stats-header.vue?vue&type=script&lang=js"
import style0 from "./stats-header.css?vue&type=style&index=0&id=add1dee6&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add1dee6",
  null
  
)

export default component.exports